import React from 'react';

interface StepProps {
  number: number;
  title: string;
  description: string;
  image: string;
}

const Step: React.FC<StepProps> = ({ number, title, description, image }) => {
  return (
    <div className="flex flex-col items-center">
      <div className="relative">
        <div className="text-2xl font-bold text-white mb-4">{number}</div>
        <div className="w-px h-20 bg-gray-700 absolute left-1/2 -bottom-20 transform -translate-x-1/2"></div>
      </div>
      
      <div className="mt-8 max-w-xs flex-1">
        <img src={image} alt={title} className="mx-auto mb-6 h-48 object-contain" />
        <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
        <p className="text-gray-400">{description}</p>
      </div>
    </div>
  );
};

const HowItWorks: React.FC = () => {
  const steps = [
    {
      number: 1,
      title: "Choose Instant Refund by ValetPe",
      description: "Select the ValetPe option when checking out at your favorite store", 
      image: require("../../assets/images/instantrefundscreenshot.png")
    },
    {
      number: 2,
      title: "Enter Your Order ID & Phone Number",
      description: "Provide your order details to process the refund request",
      image: require("../../assets/images/refundformscreenshot.png")
    },
    {
      number: 3,
      title: "Voila! Refund Amount Credited",
      description: "Get your money back instantly without waiting",
      image: require("../../assets/images/refundsuccess.png")
    },
    {
      number: 4,
      title: "Ship your items back to the retailer",
      description: "Return the items as usual to complete the process",
      image: require("../../assets/images/deliverybox.png")
    }
  ];

  return (
    <section className="bg-dark py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center bg-dark-light px-4 py-2 rounded-md mb-8">
            <svg className="w-5 h-5 mr-2 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
            <span className="text-white text-xl tracking-wider">How It Works</span>
          </div>
        </div>
        
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-300 mb-4">
          Get Priority Access to the Fast Lane
        </h2>
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-300 mb-8">
          for Instant Refunds
        </h2>
        
        <div className="text-center mb-16">
          <p className="text-xl text-gray-400">No Questions Asked!</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <Step 
              key={index}
              number={step.number}
              title={step.title}
              description={step.description}
              image={step.image}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;